import { withJsonFormsControlProps } from "@jsonforms/react";
import RadioField from "./RadioField";

const RadioFieldComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    enabled,
  } = props;
  return (
    <RadioField
      value={data}
      label={label}
      disabled={uischema.disabled || !enabled}
      updateValue={(newVal) => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  );
};

export const RadioFieldControl = withJsonFormsControlProps(RadioFieldComponent);
